import { useState } from 'react'

import { AdUnitAmazon } from 'features/globalSetup/features/amazon/types/adUnitAmazon'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_AD_UNIT_AMAZON_ALERTS } from './api/query'
import { Data, Variables } from './api/types'
import { Props, Return } from './types'

export const useGetAdUnitAmazonAlerts = ({ adUnitAmazonId }: Props): Return => {
  const [alerts, setAlerts] = useState<AdUnitAmazon['alerts']>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node } = data

      if (node !== null) {
        setAlerts(fromDTO(node).alerts)
      }
    },
    query: GET_AD_UNIT_AMAZON_ALERTS,
    variables: { id: adUnitAmazonId },
  })

  return { alerts }
}
